import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Radio extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [
        {
          title: 'default',
          isDefault: true,
        },
      ],
      modifiers : [ 
        'inverse'
      ],
      states : []
    }
  }

  render() {
    const { id, parentId, className, parentClassName, name, value, children, defaultChecked, onClick, checked, parentProps, ...rest } = this.props
    return <div id={parentId} onClick={onClick} className={resolveProps(this.props, this.config, 'Radio') + ' ' + (parentClassName || '')} {...parentProps}>
      <input 
        {...rest}
        type="radio"
        id={id}
        name={name || id}
        className={'mdn-Radio-input ' + (className || '')}
        value={value || children}
        checked={defaultChecked || checked}
      />
      <label className="mdn-Radio-label" htmlFor={id} />
      <label className="mdn-Radio-text" htmlFor={id}>
        {children}
      </label>
    </div>
  }
}

Radio.propTypes = {
  id : PropTypes.string, 
  value : PropTypes.string,
  children : PropTypes.node,
  disabled : PropTypes.bool,
  checked : PropTypes.bool,
  config : PropTypes.object
}